import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import { hasLocizeTranslation } from 'lib/utils/locize'

const SearchMessage = ({ query, hitCount, isPhone, t, countProducts }) => {
  if (!isPhone && countProducts > 0) {
    return null
  }

  const prefixCls = 'search-res'
  const classes = clsx({
    [`${prefixCls}__no-result`]: !hitCount,
    [`${prefixCls}__result`]: !!hitCount,
  })
  let content

  // sometime, totalHits(hitCount) is undefined after load more product, so send countProducts for solve the problem
  const totalCount = hitCount || countProducts

  if (countProducts === 0) {
    const searchQuery = hasLocizeTranslation(
      t,
      'SEARCH_NOT_FOUND',
      'We couldn’t find any result for "%s" to display.',
    ).replace('%s', query)

    content = (
      <Fragment>
        <Icon src={ICONS.emptySearch} size={ICON_SIZE.extraLarge} />
        <span className={clsx(Typo.h6, 'search-res__term')}>
          {t('No Results')}
        </span>
        <p className={clsx(Typo.price2, 'search-res__label')}>
          {t(searchQuery)}
        </p>
        <p className={clsx(Typo.price2, 'search-res__label')}>
          {t('Please try something else.')}
        </p>
      </Fragment>
    )
  } else {
    content = (
      <Fragment>
        <span className={Typo.caption}>{t("You've searched for")}</span>
        <h1 className={Typo.h6}>{`"${query}"`}</h1>
        <span className={Typo.caption}>
          {`${t('we found')} ${totalCount} ${t('results')}`}
        </span>
      </Fragment>
    )
  }

  return (
    <div className={classes}>
      <div className="search-res__wrapper">{content}</div>
    </div>
  )
}

SearchMessage.defaultProps = {
  hitCount: 0,
  query: '',
  countProducts: 0,
}

SearchMessage.propTypes = {
  hitCount: PropTypes.number,
  isPhone: PropTypes.bool.isRequired,
  query: PropTypes.string,
  t: PropTypes.func.isRequired,
  countProducts: PropTypes.number,
}

export { SearchMessage }

const Extended = translate('global')(SearchMessage)

export default connect(
  /* istanbul ignore next */
  (state) => ({ filter: state.filter, isPhone: state.device.isPhone }),
)(Extended)
